import React from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

import { useGlobalModalContext } from '../../../context/GlobalModal';
import { breakpoints } from '../../../theme';
import { DivFlex } from '../../Typhography';

interface ModalPropsStyle {
  width?: number;
  height?: number;
  padding?: string;
}

interface ModalProps {
  width?: number;
  isOpen?: boolean;
  height?: number;
  padding?: string;
  onRequestClose?: () => void;
  closeModal?: () => void;
  children: any;
  showCloseButton?: boolean;
}

const ButtonClose = styled.div`
  position: absolute;
  color: ${(props) => props.theme.colors.gray};
  top: 20px;
  right: 30px;
  cursor: pointer;
  z-index: 2;
`;

const Content = styled(DivFlex)`
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

const ModalStyle = styled(ReactModal)<ModalPropsStyle>`
  position: absolute;
  box-sizing: border-box;
  width: ${({ width }) => (width ? `${width}px` : '600px')};
  height: ${({ height }) => (height ? `${height}px` : undefined)};
  max-width: 95%;
  max-height: 95vh;
  top: 50%;
  left: 50%;
  border-radius: 16px;
  padding: ${({ padding }) => (padding ? padding : '20px')};
  right: auto;
  margin-right: 50%;
  bottom: auto;
  transform: translate(-50%, -50%);
  background-color: white;
  overflow-y: auto;
  @media (${breakpoints.lg}) {
    width: 80%;
  }
`;

const XIcon = styled.div`
  font-size: 30px;
`;

const Modal: React.FC<ModalProps> = ({
  width,
  height,
  padding,
  isOpen = true,
  onRequestClose,
  showCloseButton = true,
  children,
}) => {
  const { hideModal } = useGlobalModalContext();

  return (
    <ModalStyle
      height={height}
      width={width}
      padding={padding}
      overlayClassName="myoverlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      ariaHideApp={false}
    >
      {showCloseButton && (
        <ButtonClose onClick={handleModalClose}>
          <XIcon>&#10006;</XIcon>
        </ButtonClose>
      )}
      <Content>{children}</Content>
    </ModalStyle>
  );

  /**
   * Handles closing modal by invoking on close function provided by user
   */
  function handleModalClose() {
    if (onRequestClose) {
      onRequestClose();
    }

    if (isOpen) {
      hideModal();
    }
  }
};

export default Modal;
